import axios from "axios";
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const login = (form) => axiosInstance.post("/api/verification", form);

export const backLogin = (form) => axiosInstance.post("/api/backLogin", form);
